import '@ant-design/v5-patch-for-react-19';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/styles.css';

import './i18n';

import './lib/Sentry';
import { installTranslationDomGuard } from './lib/translationDomGuard';

import AppRoutes from '@app/routes/AppRoutes';
import { ApiInterceptorProvider } from '@context/api/ApiInterceptorProvider';
import { AuthProvider } from '@context/auth/AuthProvider';
import { MessageProvider } from '@context/message';
import NotificationProvider from '@context/notifications/NotificationProvider';
import RunTimeError from '@pages/RunTimeError';
import { AuthProvider as OidcProvider } from 'react-oidc-context';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';

import { ProtectedWrapper } from '@app/features/oidc/components/ProtectedWrapper';
import { purgeLegacyTokens, userManager } from '@app/features/oidc/oidc.config';
import { HeadProvider } from 'react-head';
import envConfig from './enviroment/enviroment';

const container = document.getElementById('root');

const SENTRY_DNS = envConfig.getEnvKey('SENTRY_DNS');
const SENTRY_ENVIRONMENT = envConfig.getEnvKey('SENTRY_ENVIRONMENT');

// if sentry dns then its not dev so we need to hide all the logs
if (SENTRY_DNS && SENTRY_ENVIRONMENT !== 'local-dev') {
  window.console.log = function () {};
  window.console.debug = function () {};
  window.console.warn = function () {};
  window.console.info = function () {};
}

purgeLegacyTokens();
installTranslationDomGuard();

if (container) {
  const routes: RouteObject[] = [
    {
      path: '/*',
      errorElement: <RunTimeError />,
      element: <AppRoutes />,
    },
  ];

  const router = createBrowserRouter(routes);

  if (import.meta.hot) {
    // import.meta.hot.dispose(() => router.dispose());
  }

  createRoot(container).render(
    <StrictMode>
      <OidcProvider
        userManager={userManager}
        onSigninCallback={() => {
          window.history.replaceState({}, document.title, window.location.pathname);
        }}
      >
        <ProtectedWrapper>
          <AuthProvider>
            <MessageProvider>
              <NotificationProvider>
                <ApiInterceptorProvider>
                  <HeadProvider>
                    <RouterProvider router={router} future={{ v7_startTransition: true }} />
                  </HeadProvider>
                </ApiInterceptorProvider>
              </NotificationProvider>
            </MessageProvider>
          </AuthProvider>
        </ProtectedWrapper>
      </OidcProvider>
    </StrictMode>
  );
}
